import type { VoidFunctionComponent, ReactNode } from 'react';
import Helmet from 'react-helmet';
import Loader from '../generic/Loader';
import NotFound from '../generic/NotFound';
import type { AsyncStatus } from '../../types';
import { useIsSBOMPolicyEnabled } from '../../helpers/features';
import { PolicyType } from '../../../typings/enums';

type ListSbomPoliciesPageProps = {
  renderPolicyList: (policyType: PolicyType) => ReactNode;
  status: AsyncStatus,
};

const ListSbomPoliciesPage: VoidFunctionComponent<ListSbomPoliciesPageProps> = ({
  renderPolicyList,
  status,
}) => {
  const isSbomPolicyEnabled = useIsSBOMPolicyEnabled();

  if (!isSbomPolicyEnabled) {
    return <NotFound />;
  }

  return (
    <div className="container margin-top">
      <Helmet title="Policies" />
      {status?.errors?.map(error => <div className="alert alert-error">{error}</div>)}
      {status?.loading ? <Loader /> : renderPolicyList(PolicyType.SBOM)}
    </div>
  );
};

export default ListSbomPoliciesPage;
